// store/categories/thunks.ts

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetCategoriesParams,
  GetCategoryRequest,
  UpdateCategoryRequest,
  CategoryFullSchema,
} from '@/types/categories';
import { categoriesService } from '../../services/categories.service';
import { showSnackbar } from '../snakebar/slice';

// --------------------------------------- CORE CATEGORIES ---------------------------------------

export const getCategories = createAsyncThunk(
  'categories/getCategories',
  async (params: GetCategoriesParams | undefined, { rejectWithValue }) => {
    try {
      const response = await categoriesService.getCategories(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch categories');
    }
  }
);

export const getCategory = createAsyncThunk(
  'categories/getCategory',
  async (request: GetCategoryRequest, { rejectWithValue }) => {
    try {
      const response = await categoriesService.getCategory(request);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch category');
    }
  }
);

export const updateCategory = createAsyncThunk(
  'categories/updateCategory',
  async (request: UpdateCategoryRequest, { dispatch, rejectWithValue }) => {
    try {
      const response = await categoriesService.updateCategory(request);
      dispatch(
        showSnackbar({
          message: 'Successfully updated category!',
          variant: 'success',
        })
      );
      return response;
    } catch (error: any) {
      dispatch(
        showSnackbar({
          message: error instanceof Error ? error.message : 'Failed to update category',
          variant: 'error',
        })
      );
      return rejectWithValue(error.response?.data?.message || 'Failed to update category');
    }
  }
);

// ------------------------------------ GROUPED EXPORTS ------------------------------------

export const categories = {
  getCategories,
  getCategory,
  updateCategory,
};
